module.exports = __webpack_public_path__ + "img/pic-02.cbff3cd0.jpg";